import magicStyles from './countdown.magic.css.js';
import script from './countdown.js';
export { TimeSegment } from './countdown.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.simple && !_vm.monospace)?_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.asString}}):(_vm.simple && _vm.monospace)?_c('p',{staticClass:"text text--monospace",attrs:{"part":"text text--monospace"},domProps:{"innerHTML":_vm._s(_vm.asString)}}):_c('div',{staticClass:"countdown",style:({
        '--magic-countdown-columns': _vm.labels.length,
    }),attrs:{"part":"countdown"}},[_vm._l((_vm.digits),function(digit,index){return _c('magic-ui-text',{key:index,staticClass:"text text--digit",attrs:{"tag":"p","part":"text text--digit","content":digit}})}),_vm._v(" "),_vm._l((_vm.labels),function(label){return _c('magic-ui-text',{key:label,staticClass:"text text--label",attrs:{"tag":"p","part":"text text--label","content":_vm.$t(("countdown.label." + label))}})})],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4666b555_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-4666b555";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
